import { Alert, Flex, Tabs, Typography } from "djuno-design";
import { useNavigate } from "react-router-dom";
import ExpandableCard from "../components/ExpandableCard";
import { tabsPageUrl } from "../urls";
const { Title, Text } = Typography;

const tabOptions = [
  { label: "Tab1", url: tabsPageUrl },
  { label: "Tab2", url: tabsPageUrl },
  { label: "tab3", url: tabsPageUrl },
];

const TabsWithUrlPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Flex direction="col">
        <Title level={4}>Tabs with URL</Title>
        <Text size="sm" style={{ marginBottom: 30 }}>
          The Tabs component offers a dynamic tabbed navigation system that
          allows users to switch between different content sections. As users
          interact with the tabs, the browser’s URL is automatically updated to
          reflect the active tab, making it easier to bookmark or share specific
          sections. This feature enhances navigation by ensuring each tab has a
          distinct, URL-friendly path, improving both user experience and search
          engine optimization.
        </Text>
        <Alert
          uiType="info"
          showIcon={true}
          message={
            <Flex direction="row" items="center" className="gap-3">
              <Text size="xs">
                This implementation of the{" "}
                <Text size="xs" strong>
                  Tabs component
                </Text>{" "}
                integrates{" "}
                <Text size="xs" strong>
                  URL-based navigation
                </Text>{" "}
                using the{" "}
                <Text size="xs" strong>
                  navigator function
                </Text>{" "}
                from the{" "}
                <Text size="xs" strong>
                  DjunoDesignProvider
                </Text>{" "}
                context. On initial load, it checks the current URL (
                <Text size="xs" strong>
                  location.pathname
                </Text>
                ) to set the appropriate tab based on the options array. When a
                tab is clicked, the{" "}
                <Text size="xs" strong>
                  onChangeTab function
                </Text>{" "}
                triggers, updating the selected tab, invoking the{" "}
                <Text size="xs" strong>
                  onChange callback
                </Text>{" "}
                (if provided), and using{" "}
                <Text size="xs" strong>
                  navigator
                </Text>{" "}
                to update the browser's URL with the selected tab's URL. This
                allows{" "}
                <Text size="xs" strong>
                  dynamic URL synchronization
                </Text>
                , enabling direct linking to specific tabs.
              </Text>
            </Flex>
          }
        />

        <Flex direction="col" className="w-full">
          <Title level={5} className="mt-4">
            Examples
          </Title>

          <ExpandableCard
            title="Tabs with handle url"
            className="w-full md:w-1/2"
            codeViewerProps={{
              code: TabExample1,
            }}
          >
            <Flex direction="col" className="gap-5 w-full">
              <Tabs
                options={tabOptions}
                onChange={() => navigate(tabsPageUrl)}
              />
            </Flex>
          </ExpandableCard>
        </Flex>
      </Flex>
    </div>
  );
};

const TabExample1 = `
const navigate = useNavigate();

const tabOptions = [
{ label: "Tab1", url: tabsPageUrl },
{ label: "Tab2", url: tabsPageUrl },
{ label: "tab3", url:tabsPageUrl },
];
<Flex direction="col" className="gap-5 w-full">
  <Tabs options={tabOptions} onChange={() => navigate(tabsPageUrl)} />
</Flex>`;

export default TabsWithUrlPage;
